import { NgModule } from '@angular/core';
import { ApiService, BankingService, MaritimebankService, TechcombankService, ExcelService } from './services/all';
import { JvCommonModule } from '../../../../projects/jv-common/src/public_api';

@NgModule({

  imports: [
    JvCommonModule
  ],

  providers: [
    ApiService,
    BankingService,
    MaritimebankService,
    TechcombankService,
    ExcelService,
  ]
})
export class AccountingModule { }
